<template>
  <div class="container text-center">
    <span class="bookACall_title">Need help from a senior expert?</span>
    <a href="https://outlook.office365.com/owa/calendar/innopearl@innopearl.ch/bookings/" target="_blank" type="button" name="button" class='bookacall_cta'>Book a call</a>
  </div>
</template>

<script>

export default {
  name:'BookACall'
}
</script>

<style media="screen">
  .bookACall_title{
    text-align: center;
    font-size:12px;
    line-height: 15px;
letter-spacing: 0px;
color: #000000;
text-transform: uppercase;
opacity: 1;
display:block;
  }

  .bookacall_cta{
    background: #575757 0% 0% no-repeat padding-box;
box-shadow: 0px 3px 6px #00000029;
border-radius: 50px;
padding: 14px 44px;
color:#FFF !important;
display:inline-block;
text-decoration: none;
font-size:12px;
line-height: 15px;
margin:auto;
margin-top:10px;
  }
</style>
